import { createDataTool } from "./data-tool-app.js";
import { jsonToCsv } from "./json-to-csv-core.js";
import "./data-tool.css";

createDataTool({
  inputLabel: "JSON",
  outputLabel: "CSV",
  extensions: ["json"],
  defaultFileName: "data.json",
  exampleFileName: "people.json",
  example: '[{"name":"Ada","language":"Analytical Engine","active":true},{"name":"Grace","language":"COBOL","active":true}]',
  outputExtension: "csv",
  mimeType: "text/csv",
  suffix: "converted",
  transform(source) {
    const delimiter = document.getElementById("dataToolDelimiter")?.value || ",";
    return jsonToCsv(source, { delimiter });
  },
  successMessage: result => `Converted ${result.records.toLocaleString("en-US")} records into ${result.columns.toLocaleString("en-US")} columns.`
});
